import React, { useEffect, useState } from 'react'
import { IBaseDynamicFormElement, ISelectFieldSingleItem } from '../Form/DynamicForm'
import { InputLabel, MenuItem, Select } from '@mui/material'

export default function SelectFieldElement(props: IBaseDynamicFormElement) {

    const { id, label, fullWidth, handleOnChange, data, items, addNoneItem } = props

    const [value, setValue] = useState<any>("")

    const labelId = "label_of_" + id

    const renderItems = () => {

        if (items && items.length > 0){
            return items.map((item: ISelectFieldSingleItem, index: number) => <MenuItem value={item.value} key={index}>{item.name}</MenuItem>)
        }
        
        return <></>
    }

    useEffect(() => {
        setValue(data.value)
    }, [data.value])

    return(
        <>
                <InputLabel id={labelId}>{label}</InputLabel>
                <Select
                    labelId={labelId}
                    id={id}
                    value={value}
                    label={label}
                    name={id}
                    onChange={(e) => handleOnChange(id, e.target.value)}
                    error={data.helperTextType === "error" ? true : false}
                    disabled={data.disabled}
                    fullWidth={fullWidth}
                >
                    {addNoneItem && <MenuItem value="" >None</MenuItem>}
                    {renderItems()}
                </Select>
        </>
    )
}